import React, { useState } from 'react';
import axios from 'axios';
import { Lock, ShieldCheck, LogIn } from 'lucide-react';

export default function AccessGate({ onSuccess }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!username || !password) {
      setError('Unesite korisničko ime i lozinku.');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const { data } = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/gate/login`, { username, password });
      localStorage.setItem('eturizam_gate', data.token);
      onSuccess();
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === 'string' ? d : 'Prijava nije uspjela. Pokušajte ponovo.');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#001752] flex flex-col items-center justify-center px-4 relative overflow-hidden" data-testid="access-gate">
      <div className="absolute inset-0 opacity-[0.06]"
        style={{ backgroundImage: 'radial-gradient(circle at 25% 25%, #ffffff 1px, transparent 1px)', backgroundSize: '28px 28px' }} />
      <div className="relative w-full max-w-md">
        <div className="bg-white rounded-2xl shadow-2xl shadow-black/30 p-8 sm:p-10">
          <div className="flex flex-col items-center text-center mb-8">
            <img src="/favicon.png" alt="Grb" className="h-16 w-16 mb-4" />
            <h1 className="text-xl font-bold text-[#001752]">IS E-Turizam</h1>
            <p className="text-sm text-slate-500 mt-1">
              Ministarstvo privrede / Ministarstvo gospodarstva<br />SBK / KSB – Travnik
            </p>
          </div>

          <div className="flex items-start gap-2.5 bg-[#f0f3fb] border border-[#c7d4ee] rounded-lg p-3.5 mb-6">
            <ShieldCheck className="h-4 w-4 text-[#001752] mt-0.5 shrink-0" />
            <p className="text-xs text-slate-600 leading-relaxed text-left">
              Pristup ograničen. Demo portal je sastavni dio tenderske dokumentacije i ponude
              (ponuditelj VTZ d.o.o. Mostar). Pristupni podaci nalaze se u priloženoj dokumentaciji.
            </p>
          </div>

          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="text-xs font-semibold text-slate-500 uppercase tracking-wide">Korisničko ime</label>
              <input type="text" value={username} onChange={(e) => setUsername(e.target.value)} data-testid="gate-username"
                autoComplete="username" autoFocus
                className="mt-1.5 w-full h-11 rounded-md border border-slate-200 px-3.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#001752]/40 focus:border-[#001752]" />
            </div>
            <div>
              <label className="text-xs font-semibold text-slate-500 uppercase tracking-wide">Lozinka</label>
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="gate-password"
                autoComplete="current-password"
                className="mt-1.5 w-full h-11 rounded-md border border-slate-200 px-3.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#001752]/40 focus:border-[#001752]" />
            </div>
            {error && (
              <p className="text-sm text-red-600 bg-red-50 border border-red-100 rounded-md px-3 py-2" data-testid="gate-error">{error}</p>
            )}
            <button type="submit" disabled={loading} data-testid="gate-submit"
              className="w-full h-11 rounded-md bg-[#001752] text-white font-semibold text-sm flex items-center justify-center gap-2 hover:bg-[#0a2a7a] transition-colors duration-200 disabled:opacity-60">
              {loading ? 'Provjera...' : (<><LogIn className="h-4 w-4" /> Pristupi portalu</>)}
            </button>
          </form>

          <p className="flex items-center justify-center gap-1.5 text-[11px] text-slate-400 mt-6">
            <Lock className="h-3 w-3" /> Zaštićeni demo portal – IS „E-Turizam“ (tačka 9.2 tehničke specifikacije)
          </p>

          <div className="mt-5 pt-4 border-t border-slate-100 text-center" data-testid="gate-contact">
            <p className="text-[11px] font-semibold text-slate-500 uppercase tracking-wide mb-1.5">Kontakt za tender – VTZ d.o.o. Mostar</p>
            <p className="text-sm font-semibold text-[#001752]">Martina Martinović</p>
            <p className="text-xs text-slate-500 mt-0.5">
              <a href="mailto:financije@vtz-solutions.com" className="hover:text-[#001752] underline underline-offset-2">financije@vtz-solutions.com</a>
              {' '}·{' '}
              <a href="tel:+38763000387" className="hover:text-[#001752]">+387 63 000 387</a>
            </p>
          </div>
        </div>
        <p className="text-center text-xs text-white/50 mt-5">Izrada: VTZ d.o.o. Mostar · © 2026</p>
      </div>
    </div>
  );
}
